/**
 * View component for /my-agenda/program/:studySlug
 *
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions
import * as moduleCertificateActions from '../../moduleCertificate/moduleCertificateActions';
import * as sponsorActions from '../../sponsor/sponsorActions';
import * as studyActions from '../../study/studyActions';
import * as studyUserActions from '../../studyUser/studyUserActions';
import * as contentModuleActions from '../../contentModule/contentModuleActions';
import * as userModuleActions from '../../userModule/userModuleActions';
import * as studyRoleActions from '../../studyRole/studyRoleActions'; 

// import global components
import { SearchInput } from '../../../global/components/forms';
import Base from '../../../global/components/BaseComponent.js.jsx';
import StudyLayout from '../../study/components/StudyLayout.js.jsx';

// import components 
import AgendaTmListItem from '../components/AgendaTmListItem.js.jsx';
import SingleProgramAgendaManager from '../views/SingleProgramAgendaManager.js.jsx';

// not updating links here because this should no longer be used with london handling agenda

class ProgramAgenda extends Base {
  constructor(props) {
    super(props);
    this.state = {
      queryText: ''
    }
    this._bind(
      '_handleQuery'
    )
  }

  componentDidMount() {
    const { dispatch, loggedInUser, match } = this.props;
    dispatch(moduleCertificateActions.fetchListIfNeeded('_user', loggedInUser._id));
    dispatch(userModuleActions.fetchList('_user', loggedInUser._id));
    // dispatch(userNodeActions.fetchListIfNeeded('_user', loggedInUser._id));
    dispatch(studyActions.fetchSingleBySlug(match.params.studySlug)).then(studyRes => {
      if(studyRes.success) {
        
        // redirect to london 
        window.location.replace(`${window.agendaUrl}/${studyRes.item._organization}/${studyRes.item._id}`);

        dispatch(sponsorActions.fetchSingleIfNeeded(studyRes.item._organization));
        dispatch(studyUserActions.fetchListIfNeeded("_group", studyRes.item._id, "_user", loggedInUser._id));
        dispatch(studyRoleActions.fetchListIfNeeded('study', studyRes.item._id)); 
      } else {
        alert('something wrong')
        // TODO: proper alert 
      }
    })
  }

  _handleQuery(e) {
    this.setState({
      [e.target.name]: e.target.value.toLowerCase()
    });
  }

  render() {
    const {
      sponsorStore
      , studyStore
      , studyUserStore
      , loggedInUser
      , studyRoleStore
    } = this.props;

    const selectedStudy = studyStore.selected.getItem();
    const selectedSponsor = sponsorStore.selected.getItem();
    const studyUserList = selectedStudy ? studyUserStore.util.getList("_group", selectedStudy._id, "_user", currentUser._id) : [];

    const currentStudyUser = studyUserList ? studyUserList[0] : null;

    const currentStudyRole = currentStudyUser ? studyRoleStore.byId[currentStudyUser._groupRole] : null;

    const isEmpty = (
      !selectedStudy
      || !selectedStudy._id
      || !selectedSponsor
      || !selectedSponsor._id
    );

    const isFetching = (
      sponsorStore.selected.isFetching
      || studyStore.selected.isFetching
    )

    const studyUserText = currentStudyUser ?
      currentStudyRole && currentStudyRole.role == "unknown" ?
        `` // not much else to put here, but looks bad if site null and role == unknown
        :
        `You are currently viewing this Program (Site/Team Number: ${currentStudyUser.siteNumber}) as ${currentStudyUser.role}`
      : loggedInUser.admin ?
        `You are viewing this Program as an ADMIN`
        :
        `You do not have access to this Program - Please contact an administrator`;

    return (
      <StudyLayout>
        <Helmet
          title={"Program Agenda | Pro-ficiency"}
        />
        <div className="flex">
          <section className="section my-agenda -program">
            {/* <div className="-content-wrapper"> */}
            <div>
              {isEmpty ?
                (isFetching ?
                  <div className="u-centerText">
                    <div className="loading"></div>
                  </div>
                  :
                  <div className="u-centerText">
                    <h2>No programs were found!</h2>
                    <p>Please <Link to="/contact-us">contact</Link> your administrator if you feel this was an error.</p>
                    <p>Or navigate to your <Link to="/my-agenda">Agenda</Link> to try another program!</p>
                  </div>
                )
                :
                <div style={{ opacity: isFetching ? 0.5 : 1 }}>
                  <SingleProgramAgendaManager
                    showAll={true}
                    showOptional={true}
                    sponsor={selectedSponsor}
                    study={selectedStudy}
                    studyUserText={studyUserText}
                  />
                </div>
              }
            </div>
          </section>
        </div>
      </StudyLayout>
    )
  }
}


ProgramAgenda.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    loggedInUser: store.user.loggedIn.user
    , moduleCertificateStore: store.moduleCertificate
    , sponsorStore: store.sponsor
    , studyStore: store.study
    , studyUserStore: store.studyUser
    , contentModuleStore: store.contentModule
    , userModuleStore: store.userModule
    , studyRoleStore: store.studyRole
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(ProgramAgenda)
);



// WEBPACK FOOTER //
// modules/agenda/views/ProgramAgenda.js.jsx